import { render } from "./ReleaseNotesDialog.vue?vue&type=template&id=6394edbc&scoped=true"
import script from "./ReleaseNotesDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesDialog.vue?vue&type=script&lang=js"

import "./ReleaseNotesDialog.vue?vue&type=style&index=0&id=6394edbc&scoped=true&lang=css"
import "./ReleaseNotesDialog.vue?vue&type=style&index=1&id=6394edbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6394edbc"]])

export default __exports__